<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="secretaria-educacion" titulo="Registro de Escolaridad" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
  <div class="bloquear-azul">

  </div>
  <span class="tag is-primary is-large "
    style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
    <span class="icon">
      <i class="icon-worldwide fa-spin"></i>
    </span> &nbsp;
    <span>Cargando...</span>
  </span>
</div>

<div class="contenedor columns " style="height:100%; ">
  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; height:100%;">

      <!-- formulario -->
      <form name="form" novalidate>
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <section class="hero is-primary">
              <div class="hero-head">
                <nav class="level">
                  <!-- Left side -->
                  <div class="level-left">
                    <div class="level-item">
                      <p class="title">
                        <span *ngIf="!ctrl.cargando" class="icon is-medium">
                          <i class="icon-calendar-16"></i>
                        </span>
                        <span *ngIf="ctrl.cargando  || cargando" class="icon is-medium">
                          <i class="icon-worldwide fa-spin"></i>
                        </span>
                        <span class="icon is-medium">
                          <i class="icon-file"></i>
                        </span> Registro de Escolaridad
                      </p>
                    </div>

                  </div>

                  <!-- Right side -->
                  <div class="level-right">

                    <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                      <span class="icon fa-2x">
                        <i class="icon-back"> </i>
                      </span>
                      <span class="tooltiptext">Regresar</span>
                    </a>

                    <a class="navbar-item is-primary tooltip" (click)="cargarDatos()">
                      <span class="icon fa-2x">
                        <i class="icon-search "></i>
                      </span>
                      <span class="tooltiptext">Buscar</span>
                    </a>

                  </div>
                </nav>
              </div>
            </section>
          </div>
        </section>

        <a id="catalogos"
          (click)="ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar-catalogo', '', 'cargando_periodo');  ctrl.cargarCatalogo('logos64', 'logos64', 'logo64');"></a>
        <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>

        <section class="section" style="overflow-y:auto; overflow-x:hidden; padding: 1rem; height: 86vh;">

          <div class="columns">
            <!--<div class="column is-2">
              <label class="label">Período activos:</label>
              <div class="control has-icons-left has-icons-right">
                <div class="b-checkbox is-info text-success">
                  <input name="activos" id="activos" [(ngModel)]="activos" (change)="seleccionarActivos($event)" class="styled"
                    type="checkbox" [checked]="activos">
                  <label for="activos">
                    Todos
                  </label>
                </div>
              </div>
            </div>-->
            <div class="column is-6">
              <label class="label">Período escolar:</label>
              <div class="control has-icons-left has-icons-right">
                <span class="icon is-small is-left">
                  <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_periodo"></i>
                </span>
                <ng-select2
                  [disabled]="activos ? true : ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true"
                  [options]="ctrl.optionSelect"
                  (valueChanged)="seleccionarPeriodo($event, 'periodo-seleccionado');  ctrl.grupos = [];"
                  [data]="ctrl.periodos_escolares"></ng-select2>
              </div>
            </div>
            <a (click)="ctrl.catalogoDependiente('grupo-periodo', 'grupos', periodo_sel);"
              id="periodo-seleccionado"></a>

            <div class="column is-6">
              <label class="label">Seleccione el grupo:</label>
              <ng-select2
                [disabled]="activos ? true : ctrl.periodos_escolares ? periodo_sel && ctrl.grupos.length > 0 ? false : true : true"
                [options]="ctrl.optionSelect" (valueChanged)="seleccionarGrupo($event, ctrl.grupos);"
                [data]="ctrl.grupos"></ng-select2>
            </div>
          </div>

          <section class="tile is-ancestor" *ngIf="dato.length > 0">
            <div class="tile is-vertical is-12">
              <div class="tile">

                <div class="tile">
                  <div class="tile is-parent">
                    <article class=" tile is-child notification">
                      <p class="subtitle">
                        <i class="icon-mortarboard"></i> Carreras encontrados
                      </p>

                      <div class="content" style="font-size: 3em;">

                        {{total_carreras}}
                      </div>
                    </article>
                  </div>
                </div>

                <div class="tile">
                  <div class="tile is-parent">
                    <article class=" tile is-child notification">
                      <p class="subtitle">
                        <i class="icon-community "></i> Grupos encontrados
                      </p>

                      <div class="content" style="font-size: 3em;">

                        {{total_grupos}}
                      </div>
                    </article>
                  </div>
                </div>

                <div class="tile">
                  <div class="tile is-parent">
                    <article class=" tile is-child notification">
                      <p class="subtitle">
                        <i class="icon-election "></i> Alumnos encontrados
                      </p>

                      <div class="content" style="font-size: 3em;">

                        {{total_alumnos}}
                      </div>
                    </article>
                  </div>
                </div>

              </div>

              <div class="tile">
                <div class="tile is-parent">
                  <article class=" tile is-child notification">
                    <p class="subtitle">
                      <i class="icon-printer "></i> Imprimir <span style="color:red">(Si los nombres estan muy largos y
                        no caben en el espacio de impresión, Por favor separe el nombre de los
                        apellidos con una coma (,) ejemplo: SOR JUANA INÉS, DE LA CRUZ)</span>
                    </p>

                    <div class="content">
                      <div class="columns">
                        <div class="column is-4">
                          <nav class="panel">
                            <p class="panel-heading">
                              INSCRIPCIÓN O REINSCRIPCIÓN
                            </p>
                            <div class="panel-block">

                              <div class="field">
                                <label class="label">Nombre director{{firma.director_sexo1=='H' ? '' : 'a'}}:</label>
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" [(ngModel)]="firma.director1"
                                    [ngModelOptions]="{standalone: true}">
                                </p>
                              </div>
                            </div>
                            <div class="panel-block">
                              <div class="field">
                                <div class="b-checkbox is-info is-circular">
                                  <input id="director_sexo11" name="director_sexo1" class="styled" type="radio"
                                    value="H" [(ngModel)]="firma.director_sexo1" [ngModelOptions]="{standalone: true}"
                                    [checked]="firma.director_sexo1 == 'H'">
                                  <label for="director_sexo11" class="radio">Hombre</label>

                                  <input id="director_sexo12" name="director_sexo1" class="styled" type="radio"
                                    value="M" [(ngModel)]="firma.director_sexo1" [ngModelOptions]="{standalone: true}"
                                    [checked]="firma.director_sexo1 == 'M'">
                                  <label class="radio" for="director_sexo12">Mujer</label>
                                </div>
                              </div>
                            </div>
                            <div class="panel-block">
                              <div class="field">
                                <label class="label">Nombre quien valida:</label>
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" [(ngModel)]="firma.valida1"
                                    [ngModelOptions]="{standalone: true}">
                                </p>
                              </div>
                            </div>
                            <div class="panel-block">
                              <div class="field">
                                <div class="b-checkbox is-info is-circular">
                                  <input id="valida_sexo11" name="valida_sexo1" class="styled" type="radio" value="H"
                                    [checked]="firma.valida_sexo1 == 'H'" [(ngModel)]="firma.valida_sexo1"
                                    [ngModelOptions]="{standalone: true}">
                                  <label for="valida_sexo11" class="radio">Hombre</label>

                                  <input id="valida_sexo12" name="valida_sexo1" class="styled" type="radio" value="M"
                                    [checked]="firma.valida_sexo1 == 'M'" [(ngModel)]="firma.valida_sexo1"
                                    [ngModelOptions]="{standalone: true}">
                                  <label class="radio" for="valida_sexo12">Mujer</label>
                                </div>
                              </div>
                            </div>
                            <div class="panel-block">

                              <div class="field">
                                <label class="label">Fecha:</label>
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" type="date" [(ngModel)]="firma.fecha1"
                                    [ngModelOptions]="{standalone: true}">
                                </p>
                              </div>
                            </div>
                            <div class="panel-block">

                              <div class="field">
                                <div class="b-checkbox is-info ">
                                  <input type="checkbox" id="cancelar1" name="cancelar1" [(ngModel)]="firma.cancelar1"
                                    [checked]="firma.cancelar1" [ngModelOptions]="{standalone: true}">
                                  <label for="cancelar1">
                                    Cancelar recuadro
                                  </label>
                                </div>
                              </div>
                            </div>
                          </nav>
                        </div>
                        <div class="column is-4">
                          <nav class="panel">
                            <p class="panel-heading">
                              ACREDITACIÓN Y REGULARIZACIÓN
                            </p>
                            <div class="panel-block">
                              <div class="field">
                                <label class="label">Nombre director{{firma.director_sexo2=='H' ? '' : 'a'}}:</label>
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" [(ngModel)]="firma.director2"
                                    [ngModelOptions]="{standalone: true}">
                                </p>
                              </div>
                            </div>
                            <div class="panel-block">
                              <div class="field">
                                <div class="b-checkbox is-info is-circular">
                                  <input id="director_sexo21" name="director_sexo2" class="styled" type="radio"
                                    value="H" [(ngModel)]="firma.director_sexo2" [ngModelOptions]="{standalone: true}"
                                    [checked]="firma.director_sexo2 == 'H'">
                                  <label for="director_sexo21" class="radio">Hombre</label>

                                  <input id="director_sexo22" name="director_sexo2" class="styled" type="radio"
                                    value="M" [(ngModel)]="firma.director_sexo2" [ngModelOptions]="{standalone: true}"
                                    [checked]="firma.director_sexo2 == 'M'">
                                  <label class="radio" for="director_sexo22">Mujer</label>
                                </div>
                              </div>
                            </div>
                            <div class="panel-block">
                              <div class="field">
                                <label class="label">Nombre quien valida:</label>
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" [(ngModel)]="firma.valida2"
                                    [ngModelOptions]="{standalone: true}">
                                </p>
                              </div>
                            </div>
                            <div class="panel-block">
                              <div class="field">
                                <div class="b-checkbox is-info is-circular">
                                  <input id="valida_sexo21" name="valida_sexo2" class="styled" type="radio" value="H"
                                    [checked]="firma.valida_sexo2 == 'H'" [(ngModel)]="firma.valida_sexo2"
                                    [ngModelOptions]="{standalone: true}">
                                  <label for="valida_sexo21" class="radio">Hombre</label>

                                  <input id="valida_sexo22" name="valida_sexo2" class="styled" type="radio" value="M"
                                    [checked]="firma.valida_sexo2 == 'M'" [(ngModel)]="firma.valida_sexo2"
                                    [ngModelOptions]="{standalone: true}">
                                  <label class="radio" for="valida_sexo22">Mujer</label>
                                </div>
                              </div>
                            </div>
                            <div class="panel-block">
                              <div class="field">
                                <label class="label">Fecha:</label>
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" type="date" [(ngModel)]="firma.fecha2"
                                    [ngModelOptions]="{standalone: true}">
                                </p>
                              </div>
                            </div>
                            <div class="panel-block">
                              <div class="field">
                                <div class="b-checkbox is-info">
                                  <input type="checkbox" id="cancelar2" name="cancelar2" [(ngModel)]="firma.cancelar2"
                                    [checked]="firma.cancelar2" [ngModelOptions]="{standalone: true}">
                                  <label for="cancelar2">
                                    Cancelar recuadro
                                  </label>
                                </div>
                              </div>
                            </div>
                          </nav>
                        </div>
                        <div class="column is-4">

                          <nav class="panel">
                            <p class="panel-heading">
                              LEGALIZACIÓN DEL DOCUMENTO
                            </p>
                            <div class="panel-block">
                              <div class="field">
                                <label class="label">Nombre jef{{firma.jefe_sexo1=='H' ? 'e' : 'a'}} oficina:</label>
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" [(ngModel)]="firma.jefe1"
                                    [ngModelOptions]="{standalone: true}">
                                </p>
                              </div>
                            </div>
                            <div class="panel-block">

                              <div class="field">
                                <div class="b-checkbox is-info is-circular">
                                  <input id="jefe_sexo11" name="jefe_sexo1" class="styled" type="radio" value="H"
                                    [checked]="firma.jefe_sexo1 == 'H'" [(ngModel)]="firma.jefe_sexo1"
                                    [ngModelOptions]="{standalone: true}">
                                  <label for="jefe_sexo11" class="radio">Hombre</label>

                                  <input id="jefe_sexo12" name="jefe_sexo1" class="styled" type="radio" value="M"
                                    [checked]="firma.jefe_sexo1 == 'M'" [(ngModel)]="firma.jefe_sexo1"
                                    [ngModelOptions]="{standalone: true}">
                                  <label class="radio" for="jefe_sexo12">Mujer</label>
                                </div>
                              </div>
                            </div>

                            <div class="panel-block">
                              <div class="field">
                                <label class="label">Nombre jef{{firma.jefe_sexo2=='H' ? 'e' : 'a'}} depto:</label>
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" type="text" [(ngModel)]="firma.jefe2"
                                    [ngModelOptions]="{standalone: true}">
                                </p>
                              </div>
                            </div>

                            <div class="panel-block">
                              <div class="field">
                                <div class="b-checkbox is-info is-circular">
                                  <input id="jefe_sexo21" name="jefe_sexo2" class="styled" type="radio" value="H"
                                    [checked]="firma.jefe_sexo2 == 'H'" [(ngModel)]="firma.jefe_sexo2"
                                    [ngModelOptions]="{standalone: true}">
                                  <label for="jefe_sexo21" class="radio">Hombre</label>

                                  <input id="jefe_sexo22" name="jefe_sexo2" class="styled" type="radio" value="M"
                                    [checked]="firma.jefe_sexo2 == 'M'" [(ngModel)]="firma.jefe_sexo2"
                                    [ngModelOptions]="{standalone: true}">
                                  <label class="radio" for="jefe_sexo22">Mujer</label>
                                </div>
                              </div>
                            </div>

                            <div class="panel-block">
                              <div class="field">
                                <label class="label">Fecha:</label>
                                <p class="control has-icons-left has-icons-right">
                                  <input class="input" type="date" [(ngModel)]="firma.fecha3"
                                    [ngModelOptions]="{standalone: true}">
                                </p>
                              </div>
                            </div>

                            <div class="panel-block">
                              <div class="field">
                                <div class="b-checkbox is-info">
                                  <input type="checkbox" id="cancelar3" name="cancelar3" [(ngModel)]="firma.cancelar3"
                                    [checked]="firma.cancelar3" [ngModelOptions]="{standalone: true}">
                                  <label for="cancelar3">
                                    Cancelar recuadro
                                  </label>
                                </div>
                              </div>
                            </div>

                          </nav>

                        </div>

                      </div>

                      <div class="columns">

                        <div class="column is-2">
                          <div class="field">
                            <div class="b-checkbox is-info">
                              <input type="checkbox" id="fin_curso" name="fin_curso" [(ngModel)]="firma.fin_curso"
                                [ngModelOptions]="{standalone: true}">
                              <label for="fin_curso">
                                Estadistica fin curso
                              </label>
                            </div>
                          </div>

                          <div class="field">
                            <div class="b-checkbox is-info">
                              <input type="checkbox" id="situacion_a_na" name="situacion_a_na"
                                [(ngModel)]="firma.situacion_a_na" [ngModelOptions]="{standalone: true}">
                              <label for="situacion_a_na">
                                Antecedentes NA
                              </label>
                            </div>
                          </div>

                          <div class="field">
                            <div class="b-checkbox is-info">
                              <input type="checkbox" id="situacion_a_se" name="situacion_a_se"
                                [(ngModel)]="firma.situacion_a_se" [ngModelOptions]="{standalone: true}">
                              <label for="situacion_a_se">
                                Antecedentes SE
                              </label>
                            </div>
                          </div>
                        </div>

                        <div class="column is-2">
                          <div class="field">
                            <div class="b-checkbox is-info">
                              <input type="checkbox" id="situacion_p_na" name="situacion_p_na"
                                [(ngModel)]="firma.situacion_p_na" [ngModelOptions]="{standalone: true}">
                              <label for="situacion_p_na">
                                No acreditadas (NA)
                              </label>
                            </div>
                          </div>

                          <div class="field">
                            <div class="b-checkbox is-info">
                              <input type="checkbox" id="situacion_p_se" name="situacion_p_se"
                                [(ngModel)]="firma.situacion_p_se" [ngModelOptions]="{standalone: true}">
                              <label for="situacion_p_se">
                                Situacion escolar (SE)
                              </label>
                            </div>
                          </div>

                       
                          <div class="field">
                            <div class="b-checkbox is-info">
                              <input type="checkbox" id="calificaciones" name="calificaciones"
                                [(ngModel)]="firma.calificaciones" [ngModelOptions]="{standalone: true}">
                              <label for="calificaciones">
                                Calificacion
                              </label>
                            </div>
                          </div>
                        </div>


                        <div class="column is-4">
                          <div class="columns">
                            <div class="column is-6">
                              <div class="field">
                                <label>Color calificacion reprobado</label>
                                <div class="b-checkbox is-info is-circular">
                                  <input id="color_calf_r1" name="color_calf_r" class="styled" type="radio"
                                    value="black" [(ngModel)]="firma.color_calf_r"
                                    [ngModelOptions]="{standalone: true}">
                                  <label for="color_calf_r1" class="radio">Negro</label>

                                  <input id="color_calf_r2" name="color_calf_r" class="styled" type="radio" value="red"
                                    [(ngModel)]="firma.color_calf_r" [ngModelOptions]="{standalone: true}">
                                  <label class="radio" for="color_calf_r2">Rojo</label>
                                </div>
                              </div>
                            </div>

                            <div class="column is-6">
                              <div class="field">
                                <label>Color descripción reprobado</label>
                                <div class="b-checkbox is-info is-circular">
                                  <input id="color_calf_t1" name="color_calf_t" class="styled" type="radio"
                                    value="black" [(ngModel)]="firma.color_calf_t"
                                    [ngModelOptions]="{standalone: true}">
                                  <label for="color_calf_t1" class="radio">Negro</label>

                                  <input id="color_calf_t2" name="color_calf_t" class="styled" type="radio" value="red"
                                    [(ngModel)]="firma.color_calf_t" [ngModelOptions]="{standalone: true}">
                                  <label class="radio" for="color_calf_t2">Rojo</label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="columns">
                            <div class="column is-12">
                              <div class="field">
                                <div class="b-checkbox is-info">
                                  <input type="checkbox" id="diagonal" name="diagonal" [(ngModel)]="firma.diagonal"
                                    [ngModelOptions]="{standalone: true}">
                                  <label for="diagonal">
                                    Cancelar calificacion cuando esta vacia
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                             <!-- !se cancela se habilitara en caso de ser necesario -->
                          <!-- <div class="columns">
                            <div class="column is-12">
                              <div class="field">
                                <div class="b-checkbox is-info">
                                  <input type="checkbox" id="vacia" name="vacia" [(ngModel)]="firma.vacia"
                                    [ngModelOptions]="{standalone: true}">
                                  <label for="vacia">
                                    Cancelar 
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div> -->
                        </div>

                        <div class="column is-4">
                          <button class="button is-fullwidth is-fullheight" type="button" (click)="imprimirRegistro()"
                            style="height: 100px;">
                            <span class="icon fa-4x has-text-link">
                              <i class="icon-printer"></i>
                            </span>
                            <span class="tooltiptext">Registro de escolaridad</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </div>
          </section>

          <section  *ngIf="estado != 0">
            <div class="notification is-danger" style="text-align: center ; font-size: 20px;" >
              Se encontraron errores en el Historial Académico del alumno <strong>{{dataError.data.nombre_completo}}</strong>
            </div>
          </section>
        </section>
      </form>
    </div>
  </div>
</div>
<style>
  .field {
    width: 100% !important;
  }
</style>